import AllB2bUsers from "../Components/AllB2b";

export const B2BRoutes = [

  {
    Component: AllB2bUsers,
    path: "/all",
    exact: true,
    id: "dashboardMetaAll",
    routePath: "/dashboard/b2b/all",
    name: "All Users",
  },
  // {
  //   Component: CreateMeta,
  //   path: "/create",
  //   exact: true,
  //   id: "dashboardStoriesCreate",
  //   routePath: "/dashboard/meta/create",
  //   name: "Create Meta",
  // },
  // {
  //   Component: EditMeta,
  //   path: "/edit/:storyId",
  //   exact: true,
  //   id: 'dashboardStoriesEdit',
  // },

];


